import "../../index19.css";
import { jsxs as a, jsx as n, Fragment as de } from "react/jsx-runtime";
import { useMemo as se } from "react";
import { a as i, i as we } from "../../core-DVmjA3_O.js";
import { _ as F } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import ce from "../BlockView/index.js";
import he from "../DefaultMessage/index.js";
import le from "../Description/index.js";
import fe from "../Heading/index.js";
import I from "../InlineView/index.js";
import d from "../ListView/index.js";
import ge from "../../hooks/useSpacingToken.js";
import { getSpacingValue as pe, paddingSpacings as me } from "../../utils/style.js";
const _e = "_container_7dvqw_1", ve = "_with-centered-content_7dvqw_2", ue = "_with-fixed-height_7dvqw_8", Ce = "_with-shadow_7dvqw_13", ke = "_with-background_7dvqw_17", Be = "_with-border_7dvqw_22", Oe = "_with-dark-background_7dvqw_27", qe = "_form-variant_7dvqw_32", Se = "_before-container_7dvqw_33", be = "_content_7dvqw_38", He = "_pending-overlaid_7dvqw_43", De = "_message_7dvqw_48", ye = "_with-overflow_7dvqw_53", Ne = "_with-padding-overflow_7dvqw_54", xe = "_overflow-container_7dvqw_61", Fe = "_filters_7dvqw_68", Ie = "_with-content-well_7dvqw_73", e = {
  container: _e,
  withCenteredContent: ve,
  withFixedHeight: ue,
  withShadow: Ce,
  withBackground: ke,
  withBorder: Be,
  withDarkBackground: Oe,
  formVariant: qe,
  beforeContainer: Se,
  content: be,
  pendingOverlaid: He,
  message: De,
  withOverflow: ye,
  withPaddingOverflow: Ne,
  overflowContainer: xe,
  filters: Fe,
  withContentWell: Ie
};
function Ke(M) {
  const {
    className: P,
    elementRef: V,
    heading: C,
    withEllipsizedHeading: W,
    headingLevel: s = 3,
    headerIcons: k,
    headerActions: w,
    headerDescription: c,
    withHeaderBorder: A,
    withCenteredHeading: L,
    withCenteredHeaderDescription: j,
    withoutWrapInHeader: B,
    withLargeBreakpointInHeader: O,
    variant: h = "default",
    filters: l,
    footerIcons: q,
    footer: S,
    footerActions: b,
    withFooterBorder: z,
    withoutWrapInFooter: E,
    children: f,
    withContentOverflow: g,
    withContentWell: H,
    empty: p = !1,
    filtered: D = !1,
    pending: m = !1,
    overlayPending: _,
    errored: v = !1,
    emptyMessage: R,
    filteredEmptyMessage: $,
    pendingMessage: G,
    errorMessage: T,
    withoutMessageIcon: J,
    withCompactMessage: K,
    withBackground: Q,
    withDarkBackground: U,
    withShadow: X,
    withPadding: u,
    withBorder: Y,
    withFixedHeight: Z,
    spacing: t,
    spacingOffset: o = 0,
    withoutSpacingOpticalCorrection: r,
    withCenteredContent: ee,
    ...te
  } = M, y = i(C) || i(k) || i(w), oe = y || i(c), ne = i(S) || i(q) || i(b), ie = ge({
    spacing: t,
    offset: o,
    modes: me,
    withoutOpticalCorrection: r
  }), N = pe(t, o), re = g && u ? /* @__PURE__ */ n(
    "div",
    {
      className: e.overflowContainer,
      style: {
        padding: `0 ${N}`,
        margin: `0 calc(-1 * ${N})`
      },
      children: f
    }
  ) : f, x = (f || p || m || v || D) && /* @__PURE__ */ a(de, { children: [
    /* @__PURE__ */ n(
      he,
      {
        className: e.message,
        pending: m,
        filtered: D,
        errored: v,
        empty: p,
        overlayPending: _,
        emptyMessage: R,
        filteredEmptyMessage: $,
        pendingMessage: G,
        errorMessage: T,
        withoutIcon: J,
        compact: K
      }
    ),
    !p && !v && (!m || _) && re
  ] }), ae = se(() => B ? "none" : s > 3 ? "sm" : O ? "lg" : "md", [s, O, B]);
  return /* @__PURE__ */ a(
    ce,
    {
      ...te,
      elementRef: V,
      className: F(
        e.container,
        Q && e.withBackground,
        U && e.withDarkBackground,
        X && e.withShadow,
        H && e.withContentWell,
        Z && e.withFixedHeight,
        ee && e.withCenteredContent,
        Y && e.withBorder,
        h === "form" && e.formVariant,
        P
      ),
      spacing: t,
      spacingOffset: o,
      withoutSpacingOpticalCorrection: r,
      withPadding: u,
      beforeContainerClassName: e.beforeContainer,
      before: oe && /* @__PURE__ */ a(
        d,
        {
          spacing: t,
          spacingOffset: o,
          layout: "block",
          withSpacingOpticalCorrection: !0,
          withBackground: h === "form",
          withPadding: h === "form",
          children: [
            y && /* @__PURE__ */ n(
              I,
              {
                spacing: t,
                spacingOffset: o - 1,
                withoutSpacingOpticalCorrection: r,
                wrapBreakpoint: ae,
                before: k,
                after: w && /* @__PURE__ */ n(
                  d,
                  {
                    spacing: t,
                    spacingOffset: o - 1,
                    withSpacingOpticalCorrection: !r,
                    children: w
                  }
                ),
                children: /* @__PURE__ */ n(
                  fe,
                  {
                    level: s,
                    ellipsize: W,
                    spacing: t,
                    centerAligned: L,
                    children: C
                  }
                )
              }
            ),
            c && /* @__PURE__ */ n(le, { withCenteredContent: j, children: c })
          ]
        }
      ),
      after: ne && /* @__PURE__ */ n(
        I,
        {
          spacing: t,
          spacingOffset: o,
          withoutSpacingOpticalCorrection: r,
          before: q,
          after: b,
          wrapBreakpoint: E ? "none" : "lg",
          children: S
        }
      ),
      withBeforeSeparator: A,
      withAfterSeparator: z,
      childrenContainerClassName: F(
        e.content,
        _ && e.pendingOverlaid,
        g && e.withOverflow,
        u && g && e.withPaddingOverflow,
        H && ie
      ),
      children: [
        i(l) && /* @__PURE__ */ a(
          d,
          {
            layout: "block",
            spacing: t,
            spacingOffset: o,
            children: [
              /* @__PURE__ */ n(
                d,
                {
                  gridContentClassName: e.filters,
                  layout: "grid",
                  numPreferredGridColumns: 6,
                  spacing: t,
                  spacingOffset: o - 1,
                  children: l
                }
              ),
              x
            ]
          }
        ),
        we(l) && x
      ]
    }
  );
}
export {
  Ke as default
};
